import { render, staticRenderFns } from "./costHelp.vue?vue&type=template&id=50994471&"
import script from "./costHelp.vue?vue&type=script&lang=js&"
export * from "./costHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50994471')) {
      api.createRecord('50994471', component.options)
    } else {
      api.reload('50994471', component.options)
    }
    module.hot.accept("./costHelp.vue?vue&type=template&id=50994471&", function () {
      api.rerender('50994471', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2gpx4je7FWs50/JS/costHelp.vue"
export default component.exports